goog.provide('el8.uiwidget.FilterableFeed');

goog.require('el8.uiwidget.Feed');
goog.require('el8.model.base');


//=================================================
// This is a Feed (see that file for details)
// that supports searching (i.e., filtering)
//
// ChartFeed is a subclass of this. We also use it for
// the handout feed in letter attachments (attachmentGroups.js)
//=================================================
el8.uiwidget.FilterableFeed = function(spec) {

    spec = spec || {};

    // TODO Make sure that resync, etc work ok when feed is filtered

    this._urlFilter = spec.urlFilter;

    /**
     * UI controllers for managing filtering
     */
    this._filterNoBind = spec.filterNoBind || false;
    this._filterFieldSelector = spec.filterFieldSelector || null;
    this._filterFieldInfoText = spec.filterFieldInfoText || null;
    this._filterBtn = spec.filterBtn || null;       // selector or jQuery obj
    this._clearFilterBtn = spec.clearFilterBtn || null; // selector or jQuery obj

    // for chart search or other URLs that return more than just the filtered index in their results
    this._filterIndexProp = spec.filterIndexProp || null;

    spec['rendererConstructor'] = spec.rendererConstructor || el8.uiwidget.FilterableFeedRenderer;
    el8.uiwidget.Feed.prototype.constructor.call(this, spec);
};
el8.uiwidget.FilterableFeed.inheritsFrom(el8.uiwidget.Feed);

/**
 * Extend init method to include binding of triggers and such
 */
el8.uiwidget.FilterableFeed.prototype.init = function() {
    el8.uiwidget.Feed.prototype.init.apply(this, arguments);

    var that = this;

    /* Need filterFieldSelector (and not explictly prevented since we want to customize) */
    if (this._filterFieldSelector && !this._filterNoBind) {
        var filterInputField = $(this._filterFieldSelector, this._container);
        this._filterField = el8.service.infoField.addInfoField({
            field: filterInputField,
            infoText: this._filterFieldInfoText
        });
        var doFilter = function() {
            that.filter(that.getFilterFieldVal());
        };
        this._filterField.getInputField().on('keydown', function(e) {
            if (e.keyCode === KEYS.ENTER) {
                doFilter();
                return false;
            }
        });
        if (this._filterBtn) {
            var selector = (this._filterBtn instanceof jQuery) ? this._filterBtn.selector : this._filterBtn;
            this._container.on('click', selector, function(e) {
                doFilter();
            });
        }
    }

    /* clearFilterBtn doesn't rely on filterField being available */
    if (this._clearFilterBtn && !this._filterNoBind) {
        var selector = (this._clearFilterBtn instanceof jQuery) ? this._clearFilterBtn.selector : this._clearFilterBtn;
        this._container.on('click', selector, function(e) {
            if (that._filterField) { that.setFilterFieldVal(''); }
            that.refresh();
        });
    }

};

/**
 * Extend refresh method to turn the isFiltered flag off
 */
el8.uiwidget.FilterableFeed.prototype.refresh = function() {
    /* This is the only way by which the feed becomes unfiltered */
    this._feedRenderer._isFiltered = false;
    this.unfreeze(); // enable updates again when we lived the filtered state
    el8.uiwidget.Feed.prototype.refresh.apply(this, arguments);
};

/**
 * Main new method we're adding -- filter!
 *
 * `q` can either be a dictionary (in which case it will be directly converted to query args)
 * or a string (in which it'll be sent up under the query arg `q`)
 */
el8.uiwidget.FilterableFeed.prototype.filter = function(q) {

    if (!this._urlFilter) { return; }
    if (!this._isInit) { this.init(); }

    var urlData = _.isObject(q) ? q : {'q': q};

    /* If pass in empty query, just do a refresh and return */
    if (_.isObject(q) && !q) {
        this.refresh();
        return;
    }

    /* Otherwise, clear the rendering and proceed with filter */
    this.resetRender(true);
    this._feedRenderer.displayLoading();

    var that = this;
    $.el8_ajax({
        url: this._urlFilter,
        data: urlData,
        type: "GET",
        success: function(data) {
            that.freeze(); // want to freeze against updates when the feed is in a filtered state

            /* Want to run callbacks before showFirstPage
             * because showFirstPage may involve sync fetches that
             * will slow down user experience */
            that._feedRenderer.onFilterSuccess(q, data);

            var index = (that._filterIndexProp) ? data[that._filterIndexProp] : data;
            that.loadIndex(index);
            that._showFirstPage({scrollToFeed: true});
            
            // Log when chronological record filterd
            var record_count = index && index.length;
            el8.util.amplitude.logEvent('search chronological record', {'result count':record_count});
        },
        error_override: function() {
            that.loadIndex([]);
            that._feedRenderer.clearLoading();
            that._feedRenderer.renderError();
            that.unfreeze();
        }
    });
};

el8.uiwidget.FilterableFeed.prototype.getFilterFieldVal = function() {
    if (this._filterField) {
        return this._filterField.getVal();
    }
    return null;
};
el8.uiwidget.FilterableFeed.prototype.setFilterFieldVal = function(val) {
    if (this._filterField) {
        this._filterField.setVal(val);
    }
};

//=================================================
// Customized FeedRenderer object to support FilterableFeed
//=================================================
el8.uiwidget.FilterableFeedRenderer = function(spec) {
    spec = spec || {};
    this._resetFilterFn = spec.resetFilterFn || null;
    this._filteredCallbackFn = spec.filteredCallbackFn || null;
    this._filteredClass = spec.filteredClass || 'filterResults';

    // if an empty search should show something different than an actually empty feed
    this._emptySearchMsg = spec.emptySearchMsg || null;

    /***************
     * Holds state *
     ***************/
    this._isFiltered = false;   // Is the feed currently filtered?

    el8.uiwidget.FeedRenderer.prototype.constructor.call(this, spec);
};
el8.uiwidget.FilterableFeedRenderer.inheritsFrom(el8.uiwidget.FeedRenderer);

/**
 * Extend reset method
 */
el8.uiwidget.FilterableFeedRenderer.prototype.reset = function(forFilter) {
    el8.uiwidget.FeedRenderer.prototype.reset.apply(this, arguments);
    /* Don't clear filterField if we are about to do a filter */
    if (!forFilter && this._filterField) { this._filterField.setVal(''); }
    /* Only remove class and run resetFilterFn if feed no longer filtered */
    if (!this._isFiltered) {
        this._container.removeClass(this._filteredClass);
        if (this._resetFilterFn) { this._resetFilterFn(); }
    }
};

/**
 * Customized rendering for filtered feed
 */
el8.uiwidget.FilterableFeedRenderer.prototype.onFilterSuccess = function(q, data) {
    this._container.addClass(this._filteredClass);
    if (this._filteredCallbackFn) { this._filteredCallbackFn(q, data); }
    this._isFiltered = true;
};

/**
 * Extend renderEmpty method to treat rendering empty search results
 * as different from rendering an actually empty feed
 */
el8.uiwidget.FilterableFeedRenderer.prototype.renderEmpty = function() {
    if (this._isFiltered && this._emptySearchMsg) {
        this.reset();
        this._container.show();
        this._list.append(el8.template.uiwidget.Feed.emptyHeader({emptyMsg: this._emptySearchMsg}));
        this._needsRender = false;
    } else {
        el8.uiwidget.FeedRenderer.prototype.renderEmpty.apply(this, arguments);
    }
};
